module.exports = __webpack_public_path__ + "img/product5.6faa57ed.png";